"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useAnimationState = require("../../utils/use-animation-state");
var _hamburger = _interopRequireDefault(require("../../icons/hamburger"));
var _iconButton = _interopRequireDefault(require("../icon-button"));
require("./hamburger-button.css");
var _excluded = ["animateToCloseOnClick", "className", "closeButtonAriaLabel", "hamburgerOpen", "highContrast", "menuButtonAriaLabel", "onClick"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A hamburger button for indicating there is a menu for opening and closing.
 * When opened it animates to an X to indicate closing and when clicked in the
 * open state it animates to the closed position (hamburger). This animation
 * can be turned off by passing false with the `animateToCloseOnClick` prop.
 */
var HamburgerButton = function HamburgerButton(_ref) {
  var _ref$animateToCloseOn = _ref.animateToCloseOnClick,
    animateToCloseOnClick = _ref$animateToCloseOn === void 0 ? true : _ref$animateToCloseOn,
    className = _ref.className,
    closeButtonAriaLabel = _ref.closeButtonAriaLabel,
    _ref$hamburgerOpen = _ref.hamburgerOpen,
    hamburgerOpen = _ref$hamburgerOpen === void 0 ? false : _ref$hamburgerOpen,
    highContrast = _ref.highContrast,
    menuButtonAriaLabel = _ref.menuButtonAriaLabel,
    _ref$onClick = _ref.onClick,
    onHamburgerClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(hamburgerOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  // animation duration when opening/closing. needs to match animation-duration
  // in this components styles.css file
  var duration = 400;
  var animationState = (0, _useAnimationState.useAnimationState)(isOpen, duration);
  (0, _react.useEffect)(function () {
    setIsOpen(hamburgerOpen);
  }, [hamburgerOpen]);
  return /*#__PURE__*/_react["default"].createElement(_iconButton["default"], _extends({
    "aria-expanded": hamburgerOpen,
    ariaLabel: isOpen && animateToCloseOnClick ? closeButtonAriaLabel : menuButtonAriaLabel,
    className: className,
    highContrast: highContrast,
    onClick: function onClick() {
      animateToCloseOnClick && setIsOpen(!isOpen);
      onHamburgerClick();
    }
  }, otherProps), /*#__PURE__*/_react["default"].createElement("path", {
    className: animateToCloseOnClick ? "sb-hamburgerButton-middleLine-".concat(animationState, " sb-hamburgerButton-animation") : '',
    d: _hamburger["default"][0]
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: animateToCloseOnClick ? "sb-hamburgerButton-topLine-".concat(animationState, " sb-hamburgerButton-animation sb-hamburgerButton-animation-outer-lines") : '',
    d: _hamburger["default"][1]
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: animateToCloseOnClick ? "sb-hamburgerButton-bottomLine-".concat(animationState, " sb-hamburgerButton-animation sb-hamburgerButton-animation-outer-lines") : '',
    d: _hamburger["default"][2]
  }));
};
HamburgerButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * prop to allow users to turn off the animation, if desired.
   */
  animateToCloseOnClick: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  /**
   * `aria-label` applied to button in the open position, when it looks like an
   *  X.
   */
  closeButtonAriaLabel: _propTypes["default"].string,
  /**
   * optional prop to allow button to be seen more easily on dark backgrounds.
   */
  highContrast: _propTypes["default"].bool,
  /**
   * `aria-label` applied to button in the closed position, when it looks like
   * a hamburger.
   */
  menuButtonAriaLabel: _propTypes["default"].string
} : {};
HamburgerButton.displayName = 'HamburgerButton';
var _default = exports["default"] = HamburgerButton;